import React from 'react';
import { productImages, steps } from '../data/content';
export function HowItWorks() {
  return <section id="como-funciona" className="bg-parchment-light text-ink" data-id="element-119" data-mp="7teq5h35ft0r">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-120" data-mp="3pyhx77coef3t">
        <div className="mx-auto max-w-2xl text-center" data-id="element-121" data-mp="3q0b7cwmhzhgk">
          <h2 className="font-display text-[1.875rem] font-semibold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-122" data-mp="3tzbmo55ro1yt">
            Cómo funciona tu Botiquín
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-ink-soft" data-id="element-123" data-mp="qj3f8tkbkf87">
            Cinco pasos simples, unos pocos minutos. Siempre que lo necesites.
          </p>
        </div>

        <img src={productImages.howItWorks} alt={productImages.howItWorksAlt} loading="lazy" className="mx-auto mt-8 h-auto w-full max-w-lg drop-shadow-[0_18px_28px_rgba(22,39,63,0.18)]" data-id="element-124" data-mp="gtjv7kkvefbr" />

        <ol className="relative mx-auto mt-10 grid max-w-md gap-3 lg:mt-14 lg:max-w-none lg:grid-cols-5 lg:gap-6" data-id="element-125" data-mp="19a4ezjt9kest">
          <span aria-hidden="true" className="absolute left-[10%] right-[10%] top-6 hidden h-px bg-gold/40 lg:block" data-id="element-126" data-mp="2rmfvet9hyuqs" />
          {steps.map((step, index) => <li key={step.title} className="relative flex items-center gap-4 rounded-2xl border border-parchment-line bg-white p-4 lg:flex-col lg:items-center lg:gap-0 lg:border-0 lg:bg-transparent lg:p-0 lg:text-center" data-id="element-127" data-mp="31c96lt5q97ui" data-mpi={index}>
              <span className="flex h-12 w-12 flex-none items-center justify-center rounded-full border border-gold/60 bg-parchment-light font-display text-lg font-semibold text-gold-deep" data-id="element-128" data-mp="36au4hlxibffs">
                {index + 1}
              </span>
              <div className="lg:pt-5" data-id="element-129" data-mp="3fcjwotz7qiem">
                <h3 className="font-display text-lg font-semibold uppercase leading-snug tracking-tight text-ink lg:text-xl" data-id="element-130" data-mp="3f9fid3s1a6a8">
                  {step.title}
                </h3>
                <p className="mt-0.5 font-sans text-[0.95rem] leading-relaxed text-ink-soft lg:mt-2" data-id="element-131" data-mp="1kz29x96mtpkn">
                  {step.description}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}